import React, { useState, useEffect } from "react";
import "./userTeams.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack, ArrowForward, Sports } from "@material-ui/icons";
import { getUserAllSubscriptions } from "../../services/user.services";

import { useSelector, useDispatch } from "react-redux";
import { fetchUserSubscriptions } from "../../redux/actions/userTeamActions.js";

export default function UserTeams(props) {
  const history = useHistory();
  const { userId } = useParams();
  const dispatch = useDispatch();
  const { licenseTeamData, loading } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchUserSubscriptions(userId, JSON.parse(sessionStorage.getItem("myData"))));
  }, [dispatch, userId]);

  return (
    <div className="userTeams">
      <div className="userTeamsHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTeamsTitle">User Teams</h1>
        </div>
        <img className="userTeamsLogo" src={logoBlue} alt="logo" width="150px" />
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        licenseTeamData &&
        licenseTeamData.map((item, i) => (
          <div key={i} className="userTeamsContainer">
            <div>
              <Sports className="userTeamsImg" />
            </div>
            <div className="userTeamsDetailView">
              <div className="userTeamsName">{item.teamId.teamName}</div>
              <p className="userTeamsNickname">Nickname: {item.teamId.teamNickName}</p>
              <p className="userTeamsNickname">Colour: {item.teamId.teamColor.colorName}</p>
            </div>
            <Link to={"/team/" + item._id}>
              <button className="fwdBtn">
                <ArrowForward className="fwdBtnIcon" sx={{ fontSize: 50 }} />
              </button>
            </Link>
          </div>
        ))
      )}
    </div>
  );

}
